export enum SubscriptionLinesTabEnum {
  Standards = 'standards',
  Collections = 'collections',
  Eforms = 'eforms',
}
